import React, { createContext, useContext } from 'react';

import { WidgetGrouping, WidgetType } from 'common/Widgets/types';
import { DATA_DISPLAY_TYPE, DATA_RANGE_TYPE, PRICE_DISPLAY_TYPE } from 'common/Widgets/Widget/constants';
import { DISPLAY_VALUES, ORIENTATION_TYPE } from 'constants/charts';

import { AGGREGATION_TYPE } from '../constants';

type CommunityViewWidgetModalContent = {
  id?: number;
  name: string;
  note: string;
  type: number;
  filterId?: number;
  competitors: number[];
  careTypes: number[];
  roomTypes: number[];
  roomTypesPriceDisplay: number;
  careLevels: number[];
  medicationLevels: number[];
  reviewSources: number[];
  reviewCategories: number[];
  swotCategories: number[];
  careLevelsStatsType: number;
  medicationLevelsStatsType: number;
  amenityCategories: number[];
  contractTypes: number[];
  communityContractType?: number;
  priceDisplay: number;
  communityContractSelectionType?: number;
  initialRange: string;
  initialFormat: string;
  initialOrientation: string;
  displayValue: number;
  groupBy?: WidgetGrouping;
  originalWidget?: WidgetType;
  setName: (text: string) => void;
  setNote: (text: string) => void;
  setCompetitors: (selection: any) => void;
  setCareLevels: (selection: any) => void;
  setMedicationLevels: (selection: any) => void;
  setCareTypes: (selection: any) => void;
  setRoomTypes: (selection: any) => void;
  setRoomTypesPriceDisplay: (selection: number) => void;
  setReviewSources: (selection: any) => void;
  setReviewCategories: (selection: any) => void;
  setSwotCategories: (selection: any) => void;
  setCareLevelsStatsType: (selection: number) => void;
  setMedicationLevelsStatsType: (selection: number) => void;
  setAmenityCategories: (selection: number[]) => void;
  setContractTypes: (selection: number[]) => void;
  setCommunityContractType: (type: number) => void;
  setCommunityContractSelectionType: (type: number) => void;
  setInitialRange: (initialRange: string) => void;
  setInitialFormat: (format: string) => void;
  setInitialOrientation: (format: string) => void;
  setDisplayValue: (value: number) => void;
  setPriceDisplay: (value: number) => void;
  setGroupBy: (groupBy: WidgetGrouping) => void;
  modalType: string;
  onClose: () => void;
};

export const CommunityViewWidgetModalContext = createContext<CommunityViewWidgetModalContent>({
  id: undefined,
  name: '',
  note: '',
  type: 0,
  filterId: undefined,
  competitors: [],
  careTypes: [],
  roomTypes: [],
  roomTypesPriceDisplay: AGGREGATION_TYPE.AVG,
  careLevels: [],
  medicationLevels: [],
  reviewSources: [],
  reviewCategories: [],
  swotCategories: [],
  communityContractType: undefined,
  communityContractSelectionType: undefined,
  modalType: '',
  careLevelsStatsType: AGGREGATION_TYPE.AVG,
  medicationLevelsStatsType: AGGREGATION_TYPE.AVG,
  amenityCategories: [],
  contractTypes: [],
  initialRange: DATA_RANGE_TYPE.NOW,
  initialFormat: DATA_DISPLAY_TYPE.GRAPH,
  initialOrientation: ORIENTATION_TYPE.HORIZONTAL,
  displayValue: DISPLAY_VALUES.DISPLAY.value,
  groupBy: undefined,
  priceDisplay: PRICE_DISPLAY_TYPE.SINGLE,
  setName: () => {
    //  Do Nothing
  },
  setNote: () => {
    //  Do Nothing
  },
  setCareTypes: () => {
    //  Do Nothing
  },
  setCompetitors: () => {
    // Do Nothing
  },
  setRoomTypes: () => {
    //  Do Nothing
  },
  setRoomTypesPriceDisplay: () => {
    //  Do Nothing
  },
  setCareLevels: () => {
    //  Do Nothing
  },
  setMedicationLevels: () => {
    //  Do Nothing
  },
  setReviewSources: () => {
    //  Do Nothing
  },
  setReviewCategories: () => {
    //  Do Nothing
  },
  setSwotCategories: () => {
    //  Do Nothing
  },
  setCareLevelsStatsType: () => {
    //  Do Nothing
  },
  setMedicationLevelsStatsType: () => {
    //  Do Nothing
  },
  setAmenityCategories: () => {
    //  Do Nothing
  },
  setContractTypes: () => {
    //  Do Nothing
  },
  setCommunityContractType: () => {
    //  Do Nothing
  },
  setCommunityContractSelectionType: () => {
    //  Do Nothing
  },
  onClose: () => {
    //  Do Nothing
  },
  setInitialRange: () => {
    //  Do Nothing
  },
  setInitialFormat: () => {
    //  Do Nothing
  },
  setInitialOrientation: () => {
    //  Do Nothing
  },
  setDisplayValue: () => {
    //  Do Nothing
  },
  setGroupBy: () => {
    //  Do Nothing
  },
  setPriceDisplay: () => {
    // Do Nothing
  },
});

export const useCommunityViewWidgetModalContext = () => useContext(CommunityViewWidgetModalContext);
